module.exports = __webpack_public_path__ + "media/images/new_home/culture-a133e4e9c13ece90b5f496119a178e39.png";